import styled from 'styled-components';

import { ManualCSSTheme } from 'app/shared/theme';
import {
  withBorderCSS,
  WithBorderProps,
  withDimensionsCSS,
  WithDimensionsProps,
  withFlexCSS,
  WithFlexProps,
  withPositionCSS,
  WithPositionProps,
  withSpacingCSS,
  WithSpacingProps,
  withZIndexCSS,
  WithZIndexProps,
} from 'app/shared/components/styleUtils';

export interface FlexDivWithSpacingProps
  extends WithFlexProps,
    WithDimensionsProps,
    WithPositionProps,
    WithZIndexProps,
    WithBorderProps,
    WithSpacingProps {
  theme: ManualCSSTheme;
}

export const FlexDivWithSpacing = styled.div<FlexDivWithSpacingProps>`
  ${withFlexCSS};
  ${withDimensionsCSS};
  ${withPositionCSS};
  ${withZIndexCSS};
  ${withBorderCSS};
  ${withSpacingCSS};
`;

export default FlexDivWithSpacing;
